import { NationalIdentificationNumberCountry } from '@dreryk/personal-external-identifier-common-api';
import { IsoCode } from '@dreryk/address-common-api';

import {
   commonTranslationKeys,
   createTranslatedText,
   getCurrentLocale,
   TranslatableText,
   WithFieldController,
} from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { translationKeys } from './translations';

const nationalIdentificationNumberCountryIsoCodeGetter = (country: NationalIdentificationNumberCountry): IsoCode =>
   country.getValue().getIsoCode();

const getIdentificationNumberCountryLabel = (item?: NationalIdentificationNumberCountry): string =>
   item?.getValue().getName(getCurrentLocale()) ?? '';

const nationalIdentificationNumberCountries = NationalIdentificationNumberCountry.searchAll(getCurrentLocale());

type NationalIdentificationNumberCountryFieldProps = WithFieldController<unknown> & {
   readonly label?: TranslatableText;
};

export const NationalIdentificationNumberCountryField = (
   props: NationalIdentificationNumberCountryFieldProps
): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<NationalIdentificationNumberCountry>
            testId={'nationalIdentificationNumberCountry'}
            triggerLabelExtractor={getIdentificationNumberCountryLabel}
            controller={props.controller}
            defaultValue={null}
            label={props.label || translationKeys.nationalIdentificationNumberCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
         >
            <Select.List
               items={nationalIdentificationNumberCountries}
               keyExtractor={nationalIdentificationNumberCountryIsoCodeGetter}
            >
               {(country) => (
                  <Select.Item
                     item={country}
                     testId={nationalIdentificationNumberCountryIsoCodeGetter(country)}
                     label={createTranslatedText(getIdentificationNumberCountryLabel(country))}
                  />
               )}
            </Select.List>
         </Select>
      </StyledMaxWidth>
   );
};
